<template>
<v-card>
  <v-card>
    <v-card-text v-if="request.loading" >
      <center>
        <v-progress-circular :size="70" color='amber' class="mt-5 mb-3" indeterminate >
        </v-progress-circular><br/>
        Logging out
      </center>
    </v-card-text>
    <template v-else >
      <template v-if="request.status === 200" >
        <v-card-title class="subheading justify-center" >
          Thank you for spending some time with the Guru
        </v-card-title>
        <v-card-text >
          <center>
            <v-icon :size="70" color="info" class="mb-3" >power_off</v-icon><br/>
            You have successfully been logged out.<br/>
          </center>
        </v-card-text>

      </template>

      <template v-if="request.status === 399" >
        <v-card-text  >
          <center>
            Something went wrong. You have only been partially logged out.
          </center>
        </v-card-text>
        <v-card-actions >
          <v-spacer/>
          <v-btn @click="logout" flat :loading="request.loading" >Retry logout</v-btn>
        </v-card-actions>
      </template>
    </template>
  </v-card>
</v-card>
</template>
<script>
import { LOGOUT } from '@/store/constants'
import { mapGetters } from 'vuex'
export default {
  name: 'Logout',
  data () {
    return {
      request: {
        resource: 'auth.logout'
      }
    }
  },
  mounted () {
    this.logout()
  },
  watch: {
    logoutStatus () {
      if (this.logoutStatus === 200) {
        this.$store.dispatch(LOGOUT)
      }
    }
  },
  computed: {
    ...mapGetters(['token']),
    logoutStatus () { return this.request.status }
  },
  methods: {
    logout () {
      this.request.data = { token: this.token }
      this.request.method = 'post'
      this.$request('save', this.request)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Logout.vue?1056beea